import React, { useEffect, useState } from 'react';

const API_BASE_URL = 'https://toxsee.onrender.com';

const THERAPIES = [
  { id: 1, label: 'Paclitaxel + Trastuzumab', cancer: 'Breast Cancer', stage: 'Stage II' },
  { id: 2, label: 'Tamoxifen', cancer: 'Breast Cancer', stage: 'Stage I-II' },
  { id: 3, label: 'Anastrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 4, label: 'Letrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 5, label: 'Fulvestrant', cancer: 'Breast Cancer', stage: 'Stage IV' },
  { id: 6, label: 'Palbociclib', cancer: 'Breast Cancer', stage: 'Stage IV' },
  { id: 7, label: 'FOLFOX', cancer: 'Colorectal Cancer', stage: 'Stage III' },
  { id: 8, label: 'Capecitabine', cancer: 'Colorectal Cancer', stage: 'Stage II-III' },
  { id: 9, label: 'Cetuximab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 10, label: 'Bevacizumab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 11, label: 'Regorafenib', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 12, label: 'Pembrolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 13, label: 'Osimertinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 14, label: 'Atezolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 15, label: 'Crizotinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 16, label: 'Docetaxel', cancer: 'Lung Cancer', stage: 'Stage III-IV' },
  { id: 17, label: 'Docetaxel', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 18, label: 'Abiraterone', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 19, label: 'Enzalutamide', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 20, label: 'Leuprolide', cancer: 'Prostate Cancer', stage: 'Stage II-IV' },
  { id: 21, label: 'Gemcitabine', cancer: 'Pancreatic Cancer', stage: 'Stage II-IV' },
  { id: 22, label: 'FOLFIRINOX', cancer: 'Pancreatic Cancer', stage: 'Stage II-III' },
  { id: 23, label: 'Nab-paclitaxel', cancer: 'Pancreatic Cancer', stage: 'Stage IV' },
  { id: 24, label: 'Carboplatin + Paclitaxel', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 25, label: 'Bevacizumab', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 26, label: 'Olaparib', cancer: 'Ovarian Cancer', stage: 'Stage IV' },
  { id: 27, label: 'Cisplatin + Gemcitabine', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 28, label: 'Atezolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 29, label: 'Pembrolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 30, label: 'Sunitinib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 31, label: 'Pazopanib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 32, label: 'Nivolumab', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 33, label: 'Sorafenib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 34, label: 'Lenvatinib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 35, label: 'Atezolizumab + Bevacizumab', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 36, label: 'Trastuzumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 37, label: 'Ramucirumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 38, label: 'FOLFOX', cancer: 'Stomach Cancer', stage: 'Stage II-III' },
  { id: 39, label: 'Cisplatin + Fluorouracil', cancer: 'Esophageal Cancer', stage: 'Stage II-III' },
  { id: 40, label: 'Docetaxel', cancer: 'Esophageal Cancer', stage: 'Stage IV' },
  { id: 41, label: 'Cisplatin', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 42, label: 'Cetuximab', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 43, label: 'Pembrolizumab', cancer: 'Head and Neck Cancer', stage: 'Stage IV' },
  { id: 44, label: 'Dabrafenib + Trametinib', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 45, label: 'Nivolumab', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 46, label: 'Ipilimumab', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 47, label: 'Imatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 48, label: 'Dasatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 49, label: 'Venetoclax', cancer: 'Acute Myeloid Leukemia', stage: 'All Stages' },
  { id: 50, label: 'Rituximab + CHOP', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 51, label: 'Brentuximab', cancer: 'Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 52, label: 'Ibrutinib', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage IV' },
  { id: 53, label: 'Bortezomib', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 54, label: 'Lenalidomide', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 55, label: 'Daratumumab', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 56, label: 'Sorafenib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },
  { id: 57, label: 'Lenvatinib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },
  { id: 58, label: 'Temozolomide', cancer: 'Glioblastoma', stage: 'Stage IV' },
  { id: 59, label: 'Bevacizumab', cancer: 'Glioblastoma', stage: 'Stage IV' },
  { id: 60, label: 'Cisplatin', cancer: 'Cervical Cancer', stage: 'Stage II-IV' },
  { id: 61, label: 'Bevacizumab', cancer: 'Cervical Cancer', stage: 'Stage IV' },
  { id: 62, label: 'Carboplatin + Paclitaxel', cancer: 'Endometrial Cancer', stage: 'Stage III-IV' },
  { id: 63, label: 'Pembrolizumab', cancer: 'Endometrial Cancer', stage: 'Stage IV' },
];

const CANCER_TYPES = [
  'Acute Myeloid Leukemia',
  'Bladder Cancer',
  'Brain Cancer',
  'Breast Cancer',
  'Cervical Cancer',
  'Chronic Myeloid Leukemia',
  'Colorectal Cancer',
  'Endometrial Cancer',
  'Esophageal Cancer',
  'Glioblastoma',
  'Head and Neck Cancer',
  'Hodgkin Lymphoma',
  'Kidney Cancer',
  'Liver Cancer',
  'Lung Cancer',
  'Melanoma',
  'Multiple Myeloma',
  'Non-Hodgkin Lymphoma',
  'Ovarian Cancer',
  'Pancreatic Cancer',
  'Prostate Cancer',
  'Stomach Cancer',
  'Thyroid Cancer',
];

const DISEASE_STAGES = ['Stage I', 'Stage I-II', 'Stage II', 'Stage II-III', 'Stage III', 'Stage IV', 'All Stages'];

const USER_ROLES = [
  { id: 'patient', label: 'Patient', description: 'I have or had cancer' },
  { id: 'caregiver', label: 'Caregiver', description: 'I care for someone with cancer' },
  { id: 'medical_professional', label: 'Medical Professional', description: 'Healthcare provider' },
  { id: 'exploring', label: 'Exploring', description: 'Learning about cancer' },
];

const CURRENT_SITUATIONS = [
  { id: 'waiting_diagnosis', label: 'Waiting for Diagnosis', description: 'Suspected cancer, awaiting confirmation' },
  { id: 'just_diagnosed', label: 'Just Diagnosed', description: 'Recently diagnosed with cancer' },
  { id: 'in_treatment', label: 'In Treatment', description: 'Currently receiving cancer treatment' },
  { id: 'no_evidence', label: 'No Evidence of Disease', description: 'Completed treatment, in remission' },
];

const ONTARIO_CANCER_CENTERS = [
  'Windsor Regional Cancer Centre',
  'Verspeeten Family Cancer Centre',
  'Waterloo Regional Health Network Cancer Centre',
  'Juravinski Cancer Centre',
  'Carlo Fidani Regional Cancer Centre',
  'Odette Cancer Centre',
  'Princess Margaret Cancer Centre',
  'Stronach Regional Cancer Centre at Southlake',
  'R.S. McLaughlin Durham Regional Cancer Centre',
  'Cancer Centre of Southeastern Ontario',
  'The Ottawa Hospital Cancer Centre',
  'Simcoe Muskoka Regional Cancer Centre',
  'Northeast Cancer Centre',
  'Regional Cancer Care Northwest',
];

const stepOrder = ['account', 'role', 'center', 'situation', 'cancer', 'stage', 'therapies'];

function PrimaryButton({ children, disabled = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        flex: 1,
        padding: '12px',
        background: 'var(--teal)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {children}
    </button>
  );
}

function SecondaryButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        flex: 1,
        padding: '12px',
        background: 'white',
        color: 'var(--teal)',
        border: '1px solid var(--teal)',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default function ProfileSetup({ user, onComplete }) {
  const isGoogleAuthUser = user?.authProvider === 'google';
  const [step, setStep] = useState('account');
  const [accountForm, setAccountForm] = useState({
    username: user?.username || '',
    name: user?.name || '',
    email: user?.email || '',
    dateOfBirth: user?.dateOfBirth ? String(user.dateOfBirth).slice(0, 10) : '',
    password: '',
    confirmPassword: '',
  });
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedSituation, setSelectedSituation] = useState('');
  const [selectedCancer, setSelectedCancer] = useState('');
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedCancerCenter, setSelectedCancerCenter] = useState('');
  const [selectedClinician, setSelectedClinician] = useState('');
  const [selectedTherapies, setSelectedTherapies] = useState([]);
  const [clinicians, setClinicians] = useState([]);
  const [cancerSearch, setCancerSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isMedicalProfessional = selectedRole === 'medical_professional';
  const filteredTherapies = THERAPIES.filter((therapy) => therapy.cancer === selectedCancer);

  useEffect(() => {
    const loadClinicians = async () => {
      if (!selectedCancerCenter || isMedicalProfessional) {
        setClinicians([]);
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/api/clinicians?cancerCenter=${encodeURIComponent(selectedCancerCenter)}`);
        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setClinicians(Array.isArray(data.clinicians) ? data.clinicians : []);
      } catch {
        setClinicians([]);
      }
    };

    loadClinicians();
  }, [isMedicalProfessional, selectedCancerCenter]);

  useEffect(() => {
    if (selectedClinician && !clinicians.some((clinician) => clinician.username === selectedClinician)) {
      setSelectedClinician('');
    }
  }, [clinicians, selectedClinician]);

  const handleAccountChange = (event) => {
    const { name, value } = event.target;
    setAccountForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTherapyToggle = (therapyId) => {
    setSelectedTherapies((prev) =>
      prev.includes(therapyId)
        ? prev.filter((id) => id !== therapyId)
        : [...prev, therapyId]
    );
  };

  const handleNext = () => {
    if (step === 'account') {
      if (!accountForm.username || !accountForm.name || !accountForm.email || !accountForm.dateOfBirth) {
        setError('Username, name, email, and date of birth are required');
        return;
      }
      if (accountForm.username.trim().length < 3) {
        setError('Username must be at least 3 characters');
        return;
      }
      if (!isGoogleAuthUser && accountForm.password && accountForm.password.trim().length < 6) {
        setError('Password must be at least 6 characters');
        return;
      }
      if (!isGoogleAuthUser && accountForm.password && accountForm.password !== accountForm.confirmPassword) {
        setError('Password and confirmation do not match');
        return;
      }

      setError('');
      setStep('role');
      return;
    }

    if (step === 'role') {
      if (!selectedRole) {
        setError('Please select your role');
        return;
      }

      setError('');
      setStep(isMedicalProfessional ? 'center' : 'situation');
      return;
    }

    if (step === 'center') {
      if (!selectedCancerCenter) {
        setError('Please select your cancer center');
        return;
      }

      setError('');
      handleComplete();
      return;
    }

    if (step === 'situation') {
      if (!selectedSituation) {
        setError('Please select your current situation');
        return;
      }

      setError('');
      setStep('cancer');
      return;
    }

    if (step === 'cancer') {
      if (!selectedCancer) {
        setError('Please select a cancer type');
        return;
      }

      setError('');
      setStep('stage');
      return;
    }

    if (step === 'stage') {
      if (!selectedStage) {
        setError('Please select a disease stage');
        return;
      }

      setError('');
      setStep('therapies');
      return;
    }

    if (step === 'therapies') {
      if (selectedTherapies.length === 0) {
        setError('Please select at least one therapy');
        return;
      }
      if (selectedRole === 'patient' && !selectedCancerCenter) {
        setError('Please choose your cancer center');
        return;
      }

      setError('');
      handleComplete();
    }
  };

  const handleBack = () => {
    const currentStepIndex = stepOrder.indexOf(step);
    if (currentStepIndex <= 0) {
      return;
    }

    if (step === 'center') {
      setStep('role');
      setError('');
      return;
    }

    if (step === 'situation') {
      setStep('role');
      setError('');
      return;
    }

    setStep(stepOrder[currentStepIndex - 1]);
    setError('');
  };

  const handleComplete = async () => {
    setLoading(true);
    setError('');

    try {
      const accountResponse = await fetch(`${API_BASE_URL}/api/account-details`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({
          currentUsername: user.username,
          username: accountForm.username,
          name: accountForm.name,
          email: accountForm.email,
          dateOfBirth: accountForm.dateOfBirth,
          password: isGoogleAuthUser ? '' : (accountForm.password || ''),
        }),
      });

      const accountData = await accountResponse.json();

      if (!accountResponse.ok) {
        throw new Error(accountData.error || 'Failed to save account details');
      }

      const therapyDetails = selectedTherapies
        .map((id) => THERAPIES.find((therapy) => therapy.id === id))
        .filter(Boolean);

      const profilePayload = isMedicalProfessional
        ? {
            username: accountData.user.username,
            role: selectedRole,
            currentSituation: 'not_applicable',
            cancerType: 'not_applicable',
            diseaseStage: 'not_applicable',
            cancerCenter: selectedCancerCenter,
            assignedClinician: null,
            therapies: [],
          }
        : {
            username: accountData.user.username,
            role: selectedRole,
            currentSituation: selectedSituation,
            cancerType: selectedCancer,
            diseaseStage: selectedStage,
            cancerCenter: selectedCancerCenter || null,
            assignedClinician: selectedClinician || null,
            therapies: therapyDetails,
          };

      const profileResponse = await fetch(`${API_BASE_URL}/api/user-profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify(profilePayload),
      });

      const profileData = await profileResponse.json();

      if (!profileResponse.ok) {
        throw new Error(profileData.error || 'Failed to save profile');
      }

      localStorage.setItem('user', JSON.stringify(accountData.user));
      localStorage.setItem('userProfile', JSON.stringify(profileData.profile));

      onComplete({
        ...profileData.profile,
        account: accountData.user,
      });
    } catch (setupError) {
      setError(setupError.message || 'Unable to finish setup right now.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--page-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '40px',
        maxWidth: '520px',
        width: '100%',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          marginBottom: '32px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'var(--brand-primary-light)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
          }}>
            <img src="/logo192.png" alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '4px' }} />
          </div>
          <span style={{
            fontWeight: '700',
            fontSize: '24px',
            color: 'var(--teal)',
          }}>
            Reaxano
          </span>
        </div>

        <div style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '32px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}>
          {stepOrder
            .filter((item) => !(item === 'center' && !isMedicalProfessional && selectedRole))
            .filter((item) => !(item === 'situation' && isMedicalProfessional))
            .filter((item) => !(item === 'cancer' && isMedicalProfessional))
            .filter((item) => !(item === 'stage' && isMedicalProfessional))
            .filter((item) => !(item === 'therapies' && isMedicalProfessional))
            .map((item) => (
              <div
                key={item}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  background: item === step ? 'var(--teal)' : '#ddd',
                }}
              />
            ))}
        </div>

        <h2 style={{
          marginBottom: '8px',
          fontSize: '22px',
          fontWeight: '600',
          color: '#1a1a1a',
        }}>
          Finish Setting Up Your Account
        </h2>
        <p style={{
          marginBottom: '24px',
          fontSize: '14px',
          color: '#666',
        }}>
          Google sign-in worked. We just need a few more details before we can personalize Reaxano for you.
        </p>

        {error && (
          <div style={{
            marginBottom: '16px',
            padding: '12px',
            background: '#FEE',
            border: '1px solid #FCC',
            borderRadius: '8px',
            color: '#C33',
            fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        {step === 'account' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
              <input type="text" name="username" value={accountForm.username} onChange={handleAccountChange} placeholder="Username" style={inputStyle} />
              <input type="text" name="name" value={accountForm.name} onChange={handleAccountChange} placeholder="Full Name" style={inputStyle} />
              <input type="email" name="email" value={accountForm.email} onChange={handleAccountChange} placeholder="Email" style={inputStyle} />
              <input type="date" name="dateOfBirth" value={accountForm.dateOfBirth} onChange={handleAccountChange} style={inputStyle} />
              {!isGoogleAuthUser && (
                <>
                  <input type="password" name="password" value={accountForm.password} onChange={handleAccountChange} placeholder="Create a password (optional)" style={inputStyle} />
                  <input type="password" name="confirmPassword" value={accountForm.confirmPassword} onChange={handleAccountChange} placeholder="Confirm password" style={inputStyle} />
                </>
              )}
            </div>
            {isGoogleAuthUser && (
              <p style={{ marginTop: '-8px', marginBottom: '24px', fontSize: '13px', color: '#666' }}>
                Your sign-in is managed through Google, so no password is needed here.
              </p>
            )}
            <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
          </>
        )}

        {step === 'role' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {USER_ROLES.map((role) => (
                <button
                  type="button"
                  key={role.id}
                  onClick={() => setSelectedRole(role.id)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedRole === role.id ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedRole === role.id ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                >
                  <div style={{ fontWeight: '600', color: '#1a1a1a' }}>{role.label}</div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{role.description}</div>
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
            </div>
          </>
        )}

        {step === 'center' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px', maxHeight: '320px', overflowY: 'auto' }}>
              {ONTARIO_CANCER_CENTERS.map((center) => (
                <button
                  type="button"
                  key={center}
                  onClick={() => setSelectedCancerCenter(center)}
                  style={{
                    padding: '14px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedCancerCenter === center ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedCancerCenter === center ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {center}
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext} disabled={loading}>{loading ? 'Saving...' : 'Complete Setup'}</PrimaryButton>
            </div>
          </>
        )}

        {step === 'situation' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {CURRENT_SITUATIONS.map((situation) => (
                <button
                  type="button"
                  key={situation.id}
                  onClick={() => setSelectedSituation(situation.id)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedSituation === situation.id ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedSituation === situation.id ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                >
                  <div style={{ fontWeight: '600', color: '#1a1a1a' }}>{situation.label}</div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{situation.description}</div>
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
            </div>
          </>
        )}

        {step === 'cancer' && (
          <>
            <div style={{ marginBottom: '16px' }}>
              <input
                type="text"
                value={cancerSearch}
                onChange={(event) => setCancerSearch(event.target.value)}
                placeholder="Search cancer types..."
                style={inputStyle}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px', maxHeight: '280px', overflowY: 'auto' }}>
              {CANCER_TYPES
                .filter((cancer) => cancer.toLowerCase().includes(cancerSearch.toLowerCase()))
                .map((cancer) => (
                  <button
                    type="button"
                    key={cancer}
                    onClick={() => setSelectedCancer(cancer)}
                    style={{
                      padding: '12px',
                      textAlign: 'left',
                      borderRadius: '8px',
                      border: selectedCancer === cancer ? '2px solid var(--teal)' : '1px solid #ddd',
                      background: selectedCancer === cancer ? 'var(--brand-primary-light)' : 'white',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500',
                    }}
                  >
                    {cancer}
                  </button>
                ))}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
            </div>
          </>
        )}

        {step === 'stage' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {DISEASE_STAGES.map((stage) => (
                <button
                  type="button"
                  key={stage}
                  onClick={() => setSelectedStage(stage)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedStage === stage ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedStage === stage ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                >
                  {stage}
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
            </div>
          </>
        )}

        {step === 'therapies' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px', maxHeight: '260px', overflowY: 'auto' }}>
              {filteredTherapies.map((therapy) => (
                <button
                  type="button"
                  key={therapy.id}
                  onClick={() => handleTherapyToggle(therapy.id)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedTherapies.includes(therapy.id) ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedTherapies.includes(therapy.id) ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <input type="checkbox" checked={selectedTherapies.includes(therapy.id)} onChange={() => {}} />
                    <div>
                      <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>{therapy.label}</div>
                      <div style={{ fontSize: '13px', color: '#666' }}>{therapy.stage}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label htmlFor="profile-setup-center" style={labelStyle}>
                Cancer Center {selectedRole === 'patient' ? '(required)' : '(optional)'}
              </label>
              <select id="profile-setup-center" value={selectedCancerCenter} onChange={(event) => setSelectedCancerCenter(event.target.value)} style={inputStyle}>
                <option value="">Choose a cancer center</option>
                {ONTARIO_CANCER_CENTERS.map((center) => (
                  <option key={center} value={center}>
                    {center}
                  </option>
                ))}
              </select>

              <label htmlFor="profile-setup-clinician" style={{ ...labelStyle, marginTop: '14px' }}>
                Clinician (optional)
              </label>
              <select
                id="profile-setup-clinician"
                value={selectedClinician}
                onChange={(event) => setSelectedClinician(event.target.value)}
                disabled={!selectedCancerCenter}
                style={{
                  ...inputStyle,
                  opacity: selectedCancerCenter ? 1 : 0.6,
                }}
              >
                <option value="">
                  {selectedCancerCenter ? 'No clinician selected' : 'Select a cancer center first'}
                </option>
                {clinicians.map((clinician) => (
                  <option key={clinician.username} value={clinician.username}>
                    {clinician.name} ({clinician.username})
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <SecondaryButton onClick={handleBack}>Back</SecondaryButton>
              <PrimaryButton onClick={handleNext} disabled={loading}>{loading ? 'Saving...' : 'Complete Setup'}</PrimaryButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px',
  fontFamily: 'inherit',
  background: 'white',
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#1a1a1a',
};
